<template>
  <v-app
    style="background: linear-gradient(to left, rgb(100, 181, 246), rgb(170, 210, 249));"
  >
    <v-container class="fill-height" fluid grid-list-xl>
      <v-row align="center" justify="center">
        <v-col cols="20" sm="8" md="4">
          <v-card class="mx-auto" shaped elevation="20">
            <v-toolbar color="error" dark flat>
              <v-toolbar-title class="headline"
                >Mobil Uygulama Yönetim Paneli</v-toolbar-title
              >
            </v-toolbar>

            <v-card-text>
              <v-form ref="form" v-bind:disabled="disabled" lazy-validation>
                <v-text-field
                  type="text"
                  v-model="credentials.username"
                  label="Kullanıcı Adı"
                  :rules="usernameRules"
                  prepend-icon="person"
                  :error="hasError"
                />
                <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  v-model="credentials.password"
                  label="Parola"
                  :rules="passwordRules"
                  prepend-icon="lock"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  @click:append="showPassword = !showPassword"
                  :error="hasError"
                />
                <!-- <v-combobox
                  v-model="credentials.role"
                  :items="realms"
                  item-text="displayName"
                  item-value="realm"
                  return-object
                  label="Akıllı Şehir Seçiniz"
                  prepend-icon="login"
                  :rules="roleRules"
                ></v-combobox> -->
              </v-form>
              <p class="red--text">{{ errorMessage }}</p>
            </v-card-text>

            <v-card-actions>
              <v-btn
                v-bind:disabled="disabled"
                block
                @click="login"
                color="primary"
              >
                <span v-show="!disabled">GİRİŞ</span>
                <span v-show="disabled">
                  <v-progress-circular
                    indeterminate
                    color="warning"
                  ></v-progress-circular>
                </span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "login",
  data() {
    return {
      disabled: false,
      credentials: {
        username: "",
        password: "",
        realm: "",
      },
      usernameRules: [(v) => !!v || "Kullanıcı Adı Girilmelidir"],
      showPassword: false,
      passwordRules: [(v) => !!v || "Parola Girilmelidir"],
      roleRules: [(v) => !!v || "Akıllı Şehir Seçilmelidir"],
      error: null,
    };
  },
  computed: {
    errorMessage: function () {
      return this.$store.getters["auth/error"];
    },
    hasError() {
      return this.error !== null;
    },
    ...mapGetters({ realms: "auth/realms" }),
  },
  created() {
    this.getRealms();
  },
  methods: {
    ...mapActions(["auth/getRealms"]),

    async login() {
      if (this.$refs.form.validate()) {
        this.disabled = true;
        this.credentials.realm = this.$route.meta.realm;
        try {
          await this.$store
            .dispatch("auth/login", this.credentials)
            .then(() => {
              this.disabled = false;
              this.$router.push("/dashboard");
            })
            .catch((err) => {
              this.disabled = false;
              this.$router.push('/'+this.$route.meta.realm+'/login');
            });
        } catch (err) {
          alert(`Error: ${err}`);
        }
      }
    },
    async getRealms() {
      await this.$store.dispatch("auth/getRealms");
    },
  },
};
</script>